import { update_detail } from '@/commons/hpod';
import { sendSuccessNotice, sendErrorNotice, refreshResource } from '@/commons/utils';
import Crud from './crud'
import Vue from 'vue';
var crud = new Crud('voucher', 'mã giảm giá');

const state = {
    ...crud.state,
    selected: {
        ID: 0,
        Name: '',
        Status: 0
    }
};
const getters = {
    ...crud.getters,
};
const actions = {
    ...crud.actions,
    applyVoucher({ dispatch }, {data, id}) {
        update_detail(crud.endpoint, res => {
            if (res.data.status === 'fail') {
                sendErrorNotice(`Không thể cập nhật voucher.`);
            }
            else {
                sendSuccessNotice(`Cập nhật voucher thành công.`);
                refreshResource();
            }
        }, Vue.http, data, id, this.state.authentication.token);
    },
};
const mutations = {
    ...crud.mutations,
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};